<template>
  <div class="tabmenudemo-content">
    <div v-if="!patient">
      <p>Please select a patient</p>
    </div>
    <div v-if="upcomingSessionsData.length == 0 && patient">
      <TumorBoardNewSession />
    </div>
    <div v-for="(patient) in upcomingSessionsData" :key="patient.mrn" class="container-div">
      <div>
        <span class="date-span">{{ patient.date }}</span>
      </div>
      <div>
        <span class="tumor-board-span">{{ `${patient.tb_name} Tumor Board Meeting` }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 Omics Data Automation, Inc.
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { ref, watch, computed } from 'vue'
import { useStore } from 'vuex'
import TumorBoardNewSession from './TumorBoardNewSession.vue'

const store = useStore()
const upcomingSessionsData = ref([])
const patient = computed(() => store.getters.session.patient)
const tumorBoardSessionsData = computed(() => store.getters.session.tumorBoardSessionsData)

watch(tumorBoardSessionsData, async (newTumorBoardSessionsData) => {
  if (!newTumorBoardSessionsData) { return }
  const upcomingSessions = newTumorBoardSessionsData.Upcoming
  upcomingSessionsData.value = upcomingSessions.map(item => ({ ...item, mrn: patient.value.id }))
})

</script>

<style scoped>
.tabmenudemo-content {
  text-align: initial;
}

.date-span {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: var(--Grey500);
}

.tumor-board-span {
  font-size: 14px;
  font-weight: 400;
  line-height: 16.41px;
  letter-spacing: -0.32px;
  color: var(--Grey800);
}

.notes-span {
  font-size: 14px;
  font-weight: 300;
  line-height: 16.41px;
  letter-spacing: -0.32px;
  color: var(--Grey900);
}

.container-div {
  margin-bottom: 10%;
}
</style>
